import React from 'react';
import { useRouteError, Link, useNavigate } from 'react-router-dom';
import { FaHome, FaArrowLeft, FaExclamationTriangle } from 'react-icons/fa';

const ErrorPage = () => {
 const error = useRouteError();
 const navigate = useNavigate();
 console.error(error);

 return (
 <div className="min-h-screen bg-[#f8fcfb] flex items-center justify-center p-6 text-center transition-colors duration-300">
 <div className="max-w-xl w-full">
 {/* 404 / Error Illustration Area */}
 <div className="relative mb-12">
 <div className="w-64 h-64 bg-green-50 rounded-full mx-auto flex items-center justify-center animate-pulse overflow-hidden">
 <img
 src="https://img.freepik.com/free-vector/404-error-with-landscape-concept-illustration_114360-7898.jpg"
 alt="404 Illustration"
 className="w-full h-full object-cover mix-blend-multiply opacity-80"
 />
 </div>
 <div className="absolute -top-4 -right-4 bg-[#f39200] text-white p-6 rounded-[2rem] shadow-xl rotate-12 animate-bounce">
 <FaExclamationTriangle size={32} />
 </div>
 </div>

 {/* Error Text */}
 <h1 className="text-6xl md:text-8xl font-black text-[#143d2c] tracking-tighter mb-4">
 {error?.status === 404 ? '404' : 'Oops!'}
 </h1>
 <h2 className="text-2xl md:text-3xl font-black text-gray-800 uppercase tracking-tight mb-6">
 {error?.statusText || "Something went wrong"}
 </h2>
 <p className="text-gray-500 font-medium mb-12 max-w-md mx-auto leading-relaxed">
 {error?.status === 404
 ? "The page you're looking for might have been moved, deleted, or never existed in the first place."
 : "An unexpected error occurred. Our team has been notified and we are working to fix it."}
 </p>

 {/* Direct Action Buttons */}
 <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
 <Link
 to="/"
 className="w-full sm:w-auto bg-[#143d2c] hover:bg-[#1a4f39] text-white px-10 py-5 rounded-2xl font-black text-xs uppercase tracking-[3px] shadow-xl shadow-green-900/10 active:scale-95 transition-all flex items-center justify-center gap-3"
 >
 <FaHome size={14} /> Back to Home
 </Link>
 <button
 onClick={() => navigate(-1)}
 className="w-full sm:w-auto bg-white border-2 border-gray-100 text-gray-600 px-10 py-5 rounded-2xl font-black text-xs uppercase tracking-[3px] hover:border-[#00b259] hover:text-[#00b259] transition-all flex items-center justify-center gap-3"
 >
 <FaArrowLeft size={14} /> Go Back
 </button>
 </div>

 {/* Support Info */}
 <div className="mt-16 pt-8 border-t border-gray-100">
 <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
 Technical Error ID: {error?.status || 'UNKNOWN'}_{Math.random().toString(36).substring(7).toUpperCase()}
 </p>
 </div>
 </div>

 <style jsx="true">{`
 @keyframes pulse {
 0% { transform: scale(1); opacity: 0.1; }
 50% { transform: scale(1.05); opacity: 0.15; }
 100% { transform: scale(1); opacity: 0.1; }
 }
 `}</style>
 </div>
 );
};

export default ErrorPage;
